import React from 'react'
import { FaArrowUp } from "react-icons/fa";


function Smallfoot() {
  return (
   <div className="foot">
    <div className="flexxx">
        <p> 2024 - All Rights Reserved to dev </p>
        <a className='link' href="#Home">
        <button>
        <FaArrowUp />
        </button>
         </a>
        <p>Terms & Condition / Privacy Policy</p>
    </div>

   </div>
  )
}

export default Smallfoot
